import * as angular from "angular";
import {IController} from "angular";
import {SplitService} from "../../../commons/services/split-service.service";

export class OmsAutomaticQuotesTableRowController implements IController {

  quote: any;
  onEdit: Function;
  onDelete: Function;

  private weightFactor: any;
  private volumeFactor: any;

  /* @ngInject */
  constructor(private splitService: SplitService) {
  }

  $onInit() {
    this.weightFactor = this.splitService.getWeightUnit();
    this.volumeFactor = this.splitService.getVolumeUnit();
  }
}

angular
.module('bringoz.admin.oms')
.component('omsAutomaticQuotesTableRow', {
  bindings: {
    quote: '<',
    onEdit: '&',
    onDelete: '&'
  },
  template: require('./oms-automatic-quotes-table-row.html').default,
  controller: OmsAutomaticQuotesTableRowController
});
